// extracted by mini-css-extract-plugin
module.exports = {"profilePageWrapper":"CompanyProfilePage_profilePageWrapper__mpiCO"};